import { render } from "./ListaEncerramento.vue?vue&type=template&id=639ac8a2&scoped=true"
import script from "./ListaEncerramento.vue?vue&type=script&lang=js"
export * from "./ListaEncerramento.vue?vue&type=script&lang=js"

import "./ListaEncerramento.vue?vue&type=style&index=0&id=639ac8a2&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639ac8a2"]])

export default __exports__
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QRadio});
